
/**
 * @export
 * @enum {string}
 */
export enum KeyType {
    FULL_KEY = 'FULL_KEY',
    DEV_KEY = 'DEV_KEY'
}